"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEpgSkeletonPrograms = exports.programEndMs = exports.programStartMs = exports.formatEpgTimeRange = exports.filterVisibleEpgPrograms = exports.getNonEmptyString = exports.getEpgTitle = exports.getEpgDescription = exports.getEpgValue = exports.getEpgProgress = exports.toEpgProgram = exports.getEpgTimeRange = exports.epgDayWindow = exports.parseEpgDate = exports.epgDateKey = void 0;
var constants_1 = require("./constants");
var MINUTES_IN_DAY = 24 * 60;
var epgDateKey = function (date) { return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
].join('-'); };
exports.epgDateKey = epgDateKey;
var parseEpgDate = function (value) {
    var match = typeof value === 'string' ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) : null;
    if (match === null)
        return null;
    var date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    return (0, exports.epgDateKey)(date) === value ? date : null;
};
exports.parseEpgDate = parseEpgDate;
var epgDayWindow = function (day) { return ({
    start: new Date(day.getFullYear(), day.getMonth(), day.getDate()).getTime(),
    end: new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1).getTime(),
}); };
exports.epgDayWindow = epgDayWindow;
var EPG_PROGRAMS_LIMIT_IN_HOURS = 12;
var EPG_SKELETON_MIN_DURATION_MINUTES = 30;
var EPG_SKELETON_MAX_DURATION_MINUTES = 120;
var EPG_SKELETON_STEP_MINUTES = 30;
var getEpgTime = function (value) {
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return value.getTime();
    }
    if (typeof value !== 'string' || value.length === 0) {
        return null;
    }
    var time = Date.parse(value);
    return Number.isFinite(time) ? time : null;
};
var getEpgTimeRange = function (video) {
    var startTime = getEpgTime(video === null || video === void 0 ? void 0 : video.startTime);
    var endTime = getEpgTime(video === null || video === void 0 ? void 0 : video.endTime);
    return startTime !== null && endTime !== null && endTime > startTime ?
        { startTime: startTime, endTime: endTime }
        :
            null;
};
exports.getEpgTimeRange = getEpgTimeRange;
var toEpgProgram = function (video, channel) {
    var range = (0, exports.getEpgTimeRange)(video);
    return range === null ? null : {
        id: video.id,
        title: video.title || channel.name,
        overview: video.overview,
        thumbnail: video.thumbnail,
        links: video.links,
        runtime: video.runtime,
        releaseInfo: video.releaseInfo,
        released: video.released,
        genres: video.genres,
        cast: video.cast,
        directors: video.directors,
        ratings: video.ratings,
        startTime: new Date(range.startTime),
        endTime: new Date(range.endTime),
        channelId: channel.id,
        channelName: channel.name,
        channelLogo: channel.logo,
        deepLinks: video.deepLinks,
        raw: video,
    };
};
exports.toEpgProgram = toEpgProgram;
var getEpgProgress = function (video, now) {
    var range = (0, exports.getEpgTimeRange)(video);
    if (range === null || now < range.startTime || now >= range.endTime) {
        return null;
    }
    return Math.min(100, Math.max(0, ((now - range.startTime) / (range.endTime - range.startTime)) * 100));
};
exports.getEpgProgress = getEpgProgress;
var getEpgValue = function (isEpgVideo, video, meta, key) {
    var value = video === null || video === void 0 ? void 0 : video[key];
    if (!isEpgVideo) {
        return meta[key];
    }
    if (typeof value === 'string' && value.length > 0) {
        return value;
    }
    if (Array.isArray(value) && value.length > 0) {
        return value;
    }
    return meta[key];
};
exports.getEpgValue = getEpgValue;
var getEpgDescription = function (isEpgVideo, video, meta) {
    var _a;
    var value = (_a = video === null || video === void 0 ? void 0 : video.overview) !== null && _a !== void 0 ? _a : video === null || video === void 0 ? void 0 : video.description;
    return isEpgVideo && typeof value === 'string' && value.length > 0 ?
        value
        :
            meta.description;
};
exports.getEpgDescription = getEpgDescription;
var getEpgTitle = function (isEpgVideo, video, meta) {
    return isEpgVideo && typeof (video === null || video === void 0 ? void 0 : video.title) === 'string' && video.title.length > 0 ?
        video.title
        :
            meta.name;
};
exports.getEpgTitle = getEpgTitle;
var getNonEmptyString = function (value) {
    return typeof value === 'string' && value.length > 0 ? value : null;
};
exports.getNonEmptyString = getNonEmptyString;
var filterVisibleEpgPrograms = function (videos, now, limitInHours) {
    if (limitInHours === void 0) { limitInHours = EPG_PROGRAMS_LIMIT_IN_HOURS; }
    var maxTime = now + limitInHours * constants_1.HOUR_IN_MS;
    return videos
        .filter(function (video) {
        var range = (0, exports.getEpgTimeRange)(video);
        return (range !== null &&
            range.endTime > now &&
            range.startTime < maxTime);
    })
        .sort(function (a, b) {
        var _a, _b;
        var aRange = (0, exports.getEpgTimeRange)(a);
        var bRange = (0, exports.getEpgTimeRange)(b);
        return ((_a = aRange === null || aRange === void 0 ? void 0 : aRange.startTime) !== null && _a !== void 0 ? _a : 0) - ((_b = bRange === null || bRange === void 0 ? void 0 : bRange.startTime) !== null && _b !== void 0 ? _b : 0);
    });
};
exports.filterVisibleEpgPrograms = filterVisibleEpgPrograms;
var formatEpgTimeRange = function (startTime, endTime, language) {
    var start = getEpgTime(startTime);
    var end = getEpgTime(endTime);
    if (start === null || end === null) {
        return null;
    }
    var options = {
        hour: '2-digit',
        minute: '2-digit',
    };
    return "".concat(new Date(start).toLocaleTimeString(language, options), " - ").concat(new Date(end).toLocaleTimeString(language, options));
};
exports.formatEpgTimeRange = formatEpgTimeRange;
var programStartMs = function (program) {
    var _a;
    return (_a = getEpgTime(program.startTime)) !== null && _a !== void 0 ? _a : 0;
};
exports.programStartMs = programStartMs;
var programEndMs = function (program) {
    var _a;
    return (_a = getEpgTime(program.endTime)) !== null && _a !== void 0 ? _a : 0;
};
exports.programEndMs = programEndMs;
var seededRandom = function (seed) {
    var x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
};
var getRandomEpgSkeletonDuration = function (seed, minDuration, maxDuration, stepDuration) {
    if (minDuration === void 0) { minDuration = EPG_SKELETON_MIN_DURATION_MINUTES; }
    if (maxDuration === void 0) { maxDuration = EPG_SKELETON_MAX_DURATION_MINUTES; }
    if (stepDuration === void 0) { stepDuration = EPG_SKELETON_STEP_MINUTES; }
    var steps = ((maxDuration - minDuration) / stepDuration) + 1;
    var step = Math.floor(seededRandom(seed) * steps);
    return minDuration + step * stepDuration;
};
var getEpgSkeletonPrograms = function (rowIndex, seedOffset) {
    if (seedOffset === void 0) { seedOffset = 100; }
    var programs = [];
    var startMinutes = 0;
    var index = 0;
    while (startMinutes < MINUTES_IN_DAY) {
        var duration = getRandomEpgSkeletonDuration((rowIndex + 1) * seedOffset + index);
        var endMinutes = Math.min(startMinutes + duration, MINUTES_IN_DAY);
        programs.push({
            index: index,
            startMinutes: startMinutes,
            durationMinutes: endMinutes - startMinutes,
        });
        startMinutes = endMinutes;
        index += 1;
    }
    return programs;
};
exports.getEpgSkeletonPrograms = getEpgSkeletonPrograms;
